import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import ActionsDropdownMenu from '../common/ActionsDropdownMenu';
import { Button } from 'foundations-components/transitional/components/Button';
import UsageTracker from '../../../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MyTeamFiltersWrapper = ({
  searchInput,
  children,
  isAnyFilterSet,
  onClearAllFilters,
  tableStore
}) => {
  const isUserPinnableTable = tableStore.state.isUserPinned !== undefined;
  const handleClearAllFilters = () => {
    if (isAnyFilterSet) {
      UsageTracker.track('teamInteraction', {
        action: 'clear-all-filters'
      });
    }
    onClearAllFilters();
  };
  const handleUnpinUserChange = isUserPinned => {
    tableStore.actions.setIsUserPinned(isUserPinned);
  };
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    flexWrap: "wrap",
    gap: "200",
    marginBlockEnd: "500",
    children: [searchInput && /*#__PURE__*/_jsx(Box, {
      marginInlineEnd: "600",
      children: searchInput
    }), /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myTeam.filters.filterLabel"
      })
    }), children, isAnyFilterSet && /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(Button, {
        onClick: handleClearAllFilters,
        use: "link",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.myTeam.filters.clearAllFilters"
        })
      })
    }), /*#__PURE__*/_jsx(Box, {
      marginInlineStart: "auto",
      children: /*#__PURE__*/_jsx(ActionsDropdownMenu, {
        isUserPinned: tableStore.state.isUserPinned,
        onUnpinUserChange: isUserPinnableTable ? handleUnpinUserChange : undefined
      })
    })]
  });
};
export default MyTeamFiltersWrapper;